import { render, staticRenderFns } from "./LotteryWinners.vue?vue&type=template&id=56d5c642&scoped=true"
import script from "./LotteryWinners.vue?vue&type=script&lang=js"
export * from "./LotteryWinners.vue?vue&type=script&lang=js"
import style0 from "./LotteryWinners.vue?vue&type=style&index=0&id=56d5c642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d5c642",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default})
